import axios from "axios";
import api, { url } from "./api.js";

export default class AuthApi {
  static async login(data) {
    const credentials = `${data.email}:${data.password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(
      `${url}/api/auth/login`,
      {},
      {
        headers: {
          Authorization: `Basic ${encodedCredentials}`,
        },
        withCredentials: true,
      }
    );
  }

  static async socialLogin(data) {
    const credentials = `${data.email}:${data.password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(
      `${url}/api/auth/login/social`,
      {},
      {
        headers: {
          Authorization: `Basic ${encodedCredentials}`,
        },
        withCredentials: true,
      }
    );
  }

  static async join(email, password, data) {
    const credentials = `${email}:${password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(`${url}/api/auth/sign`, data, {
      headers: {
        Authorization: `Basic ${encodedCredentials}`,
      },
    });
  }

  static async socialJoin(email, password, data) {
    const credentials = `${email}:${password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(`${url}/api/auth/sign/social`, data, {
      headers: {
        Authorization: `Basic ${encodedCredentials}`,
      },
    });
  }

  static async idCheck(data) {
    return await api.post(`api/auth/check/account`, data);
  }

  static async nicknameCheck(data) {
    return await api.post(`api/auth/check/nickname`, data);
  }

  static async phoneCheck(data) {
    return await api.post(`api/auth/check/phone-number`, data);
  }

  static async sendSMS(data) {
    return await api.post(`api/auth/send/sms`, data);
  }

  static async verifySMS(data) {
    return await api.post(`api/auth/verify/sms`, data);
  }

  static async logout() {
    return await axios.post(
      `${url}/api/auth/logout`,
      {},
      { withCredentials: true },
    );
  }

  static async idFind(data) {
    return await api.post(`api/auth/find/account`, data);
  }

  static async pwFind(data) {
    return await api.post(`api/auth/find/pw`, data);
  }

  static async pwReset(email, password, data) {
    const credentials = `${email}:${password}`;
    const encodedCredentials = btoa(credentials);

    return await axios.post(`${url}/api/auth/reset/pw`, data, {
      headers: {
        Authorization: `Basic ${encodedCredentials}`,
      },
    });
  }
}
